import { render } from "./CustomCategoryMultimediaEditItemPane.vue?vue&type=template&id=1e027b65&scoped=true&ts=true"
import script from "./CustomCategoryMultimediaEditItemPane.vue?vue&type=script&lang=ts"
export * from "./CustomCategoryMultimediaEditItemPane.vue?vue&type=script&lang=ts"

import "./CustomCategoryMultimediaEditItemPane.vue?vue&type=style&index=0&id=1e027b65&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e027b65"]])

export default __exports__